import pluralize from 'pluralize';

export const formatPlural = pluralize;
